module.exports = __webpack_public_path__ + "images/c98477871f5029f01ea8601d3b549fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/spirits.jpg
// module id = 740
// module chunks = 0